export default {
  toasts: {
    load_error: 'No se pudieron cargar las tasas',
    failed_to_save_changes: 'No se pudieron guardar los cambios',
    changes_got_saved: 'Cambios guardados',
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  rates: {
    title: 'Margen de procesamiento',
    description:
      'Porcentaje en %, más un importe fijo y un mínimo opcionales por cobro. «Cualquier método de pago» se aplica cuando no existe una tarifa específica para el método.',
  },
};
